import { createSimpleStore } from './factories/simpleStoreFactory';
import { clearEmbeddedMode, readEmbeddedModeFromStorage, syncEmbeddedModeFromSearch } from '@/common/application/embeddedMode';

type EmbeddedModeState = {
  isEmbedded: boolean;
};

type EmbeddedModeActions = {
  syncFromSearch: (search: string) => void;
  clear: () => void;
};

export type EmbeddedModeStore = EmbeddedModeState & EmbeddedModeActions;

export const useEmbeddedModeStore = createSimpleStore<EmbeddedModeState, EmbeddedModeActions>({
  name: 'EmbeddedModeStore',
  initialState: {
    isEmbedded: typeof window !== 'undefined' ? readEmbeddedModeFromStorage() : false
  },
  actions: (set) => ({
    syncFromSearch: (search: string) => {
      set({ isEmbedded: syncEmbeddedModeFromSearch(search) });
    },
    clear: () => {
      clearEmbeddedMode();
      set({ isEmbedded: false });
    }
  })
});
